import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSales } from "../repositories/storeRep";

const initialState = {
  data: [],
  loading: false,
  error: null,
};
export const getSalesData = createAsyncThunk("sales", async (thunkAPI) => {
  const response = await getSales();
  return response;
});

export const salesSlice = createSlice({
  name: "sales",
  initialState,
  extraReducers: {
    [getSalesData.pending]: (state) => {
      state.loading = true;
    },
    [getSalesData.fulfilled]: (state, action) => {
      state.loading = false;
      const data = [
        ["2022", "50%","$746.5"],
        ["2021", "70%","$846.5"],
        ["2020", "20%","$146.5"],
        ["2019", "80%","$946.5"],
        ["2018", "20%","$246.5"],
        ["2017", "10%","$67.5"],
        ["2016", "50%","$746.5"],
      ];
     
      state.data = data;
      //state.data= Object.values(action.payload.data);
    },
    [getSalesData.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default salesSlice.reducer;
